module.exports = __webpack_public_path__ + "img/icon-aggregate.302ce06f.svg";